/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * @flow
 */

'use strict';

const base64 = require('base64-js');

function binaryToBase64(t) {
    return btoa(t);
}

module.exports = binaryToBase64;
